import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from "../../assets/logo.png";
import search from "../../assets/search-solid.svg";
import Avatar from "../../components/Avatar/Avatar";
// import Button from "../../components/Button/Button";
import "./styles.css"
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentUser } from '../../actions/currentUser';
import decode from 'jwt-decode';
const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  var User = useSelector((state) => (state.currentUserReducer));

  const handleLogout = () => {
    dispatch({type: 'LOGOUT'});
    navigate('/')
    dispatch(setCurrentUser(null))
  }

  useEffect(() => {
    const token = User?.token
    if(token){
      const decodedToken = decode(token)
      if(decodedToken.exp * 1000 < new Date().getTime()){
        handleLogout();
      }
    }
    dispatch(setCurrentUser(JSON.parse(localStorage.getItem('Profile'))))
  },[dispatch])

  return (
    <nav className='main-nav'>
      <div className='navbar'>
        <Link to="/" className='nav-logo nav-btn'><img src={logo} alt="logo" /></Link>
        <Link to="/" className='nav-item nav-btn'>About</Link>
        <Link to="/" className='nav-item nav-btn'>Products</Link>
        <Link to="/" className='nav-item nav-btn'>For Teams</Link>
        <form>
          <input type="search" placeholder="Search.." />
          <img src={search} alt="search" width="18" className="search-icon" />
        </form>
        {User === null ? 
          <Link to="/auth" className="nav-item nav-links">Login</Link> :
          <>
            <Link to={`/Users/${User?.result._id}`} style={{color:"white",textDecoration:"none"}}><Avatar backgroundColor="#009dff" px="10px" py="7px" borderRadius="50%" color="white" textDecoration="none">{User.result.name.charAt(0).toUpperCase()}</Avatar></Link>
            {/* <Button>Logout</Button> */}
            <button className='nav-item nav-links' onClick={handleLogout}>Logout</button>
          </>
        }
      </div>
    </nav>
  )
}

export default Navbar